import type { HorizonAppRouteLoaderArgs } from '#/routing/classes/types/AppRouteLoaderArgs';
import { homeRoute } from '#/routing/routes';
import { idealistRedirect } from '#/routing/utils/idealistRedirect';

export function loader({ request, context }: HorizonAppRouteLoaderArgs<never>) {
  return idealistRedirect({ request, context })(
    homeRoute.with({ lang: context.locale }),
  );
}
